module.exports = __webpack_public_path__ + "stylesheets/discount-dialog_5b1a945f0cc8011e81e2cc1c706e41dd.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/discount-dialog.less
// module id = TnCe
// module chunks = 118